<template>
  <div id="app" class="w3-white">  
    <div v-if="cookie!=1 && cookie!=2" class="w3-bottom theme-1" style="opacity:0.92">
        <div class="w3-justify w3-padding">
            A cookie-k (sütik) használata a felhasználói élmény bővítése érdekében szükségeltetik. Ha úgy dönt, hogy ezek használatát elfogadja, beleegyezését adja a honlapunkon megjelenő cookie-k fogadásába. <span class="w3-text-blue cursorpointer" v-on:click="$openPage(2)">További információk itt.</span>
        </div>
        <div class="w3-center w3-margin-bottom">
            <div v-on:click="disabledCookie" class="w3-button w3-red w3-margin-right">Nem engedélyezem</div>
            <div v-on:click="enabledCookie" class="w3-button w3-green">Engedélyezem</div>
        </div>    
    </div>
    <div v-if="cookie==2" class="w3-bottom w3-red w3-padding w3-center cursorpointer" style="opacity:0.92" v-on:click="cookie=3">Az oldal funkciói csak a cookie-k használatának engedélyezése esetén működnek. <span class="">A cookie beállítások itt módosíthatók.</span>
    </div>       
        <Spinner></Spinner>
        <LoginSpinner v-if="$store.getters.loginProcess || !$store.getters.isProfileLoad"></LoginSpinner>
        <PrivacyPolicyComp></PrivacyPolicyComp>   
        <div id="pagecontent" class="menu-color">
            <nav v-if="isShowMenu" class="w3-hide-small w3-hide-medium w3-col menu-color" style="width:300px;"><br>
                <!--
                <div class="theme-1 w3-padding w3-margin-bottom" style="margin-top:-22px;">
                    <div class="w3-left" style="margin-top:8px;">CSAVARGO1</div>
                    <div v-on:click="closeMenu()" class="w3-right-align w3-xlarge cursorpointer">
                        <font-awesome-icon icon="window-close"></font-awesome-icon>
                    </div>
                </div>
                -->
                <div class="menu-title-color w3-padding  " style="margin-top:-22px;">
                    <div class="w3-left" style="margin-top:0px;">
                        <img class="" width="160px" src="./assets/img/csgo-logo.png" >
                    </div>
                    <div v-on:click="closeMenu()" class="w3-right-align w3-xlarge cursorpointer">
                        <font-awesome-icon icon="window-close" class=""></font-awesome-icon>
                    </div>
                </div>
                <Menu v-if="cookie!=2"></Menu>                
            </nav>
            <nav v-if="isShowMenu" class="w3-hide-large w3-sidebar menu-color" style="width:300px; z-index:5000;"><br>                
                <!--
                <div class="theme-1 w3-padding w3-margin-bottom" style="margin-top:-22px;">
                    <div class="w3-left" style="margin-top:8px;">CSAVARGO</div>                    
                    <div v-on:click="closeMenu()" class="w3-right-align w3-xlarge cursorpointer ">
                        <font-awesome-icon icon="window-close"></font-awesome-icon>
                    </div>
                </div>
                -->
                <div class="menu-title-color w3-padding  " style="margin-top:-22px;">
                    <div class="w3-left" style="margin-top:0px;">
                        <img class="" width="160px" src="./assets/img/csgo-logo.png" >
                    </div>
                    <div v-on:click="closeMenu()" class="w3-right-align w3-xlarge cursorpointer">
                        <font-awesome-icon icon="window-close" class=""></font-awesome-icon>
                    </div>
                </div>
                <Menu v-if="cookie!=2"></Menu>                
            </nav>

            <div id="container" class=" w3-rest main-color" >                
                <div v-if="!isShowMenu">
                    <!--
                    <div class="w3-top theme-1" style="z-index:5000;">
                        <div class="w3-button w3-xlarge w3-hover-white" v-on:click="openMenu()">
                            <font-awesome-icon icon="bars"></font-awesome-icon>
                        </div>
                        <div class="w3-right" style="margin-top:15px; margin-right:15px;">CSAVARGO</div>  
                        <div v-if="!isOnline" class="w3-bar-item w3-button w3-hover-red w3-red">
                            <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon> OFFLINE ÁLLAPOT
                        </div>                       
                    </div>
                    <div class="w3-margin-bottom" style="height:36px;"></div>
                    -->
                    <div class="w3-top menu-title-color " style="z-index:5000;">
                        <div class="w3-button w3-xlarge w3-hover-white" v-on:click="openMenu()">
                            <font-awesome-icon icon="bars"></font-awesome-icon>
                        </div>
                        <div class="w3-right" style="margin-top:7px; margin-right:14px;">
                            <img class="" width="160px" src="./assets/img/csgo-logo.png" >
                        </div>  
                        <div v-if="!isOnline" class="w3-bar-item w3-button w3-hover-red w3-red">
                            <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon> OFFLINE ÁLLAPOT
                        </div>                       
                    </div>
                    <div class="w3-margin-bottom" style="height:36px;"></div>
                </div>    
                <main>
                    <section>
                        <router-view :key="viewKey"></router-view>                                      
                    </section> 
               </main>                                    
            </div>      

        </div>

  </div>      
</template>

<script>
const fb = require('./firebase.js');
import Spinner from './components/Spinner.vue';
import LoginSpinner from './components/LoginSpinner.vue';
import Menu from './components/Menu.vue';
import PrivacyPolicyComp from './components/PrivacyPolicyComp.vue';
export default {
    name: 'App',
    data() {
      return {
          viewKey:1,
          isShowMenu:true,
          cookie:1,
          privacypolicy:null,
          newsletter:false,
      }
    },
    components: {
      Spinner,
      LoginSpinner,
      Menu,
      PrivacyPolicyComp
    },
    watch:{
        $route (to, from){
            if (!window.matchMedia('screen and (min-width: 993px)').matches) {
                this.isShowMenu=false;
            }
        }
    },     
    methods:{
        updateViewKey(){
            this.viewKey+=1;
            if (!window.matchMedia('screen and (min-width: 993px)').matches) {
                this.isShowMenu=false;
            }
        },
        signOut(){
            this.$storage.set('isLoginProcess', false);  
            fb.SignOut().then(res=>{
                this.$storage.set('favoriteList', []);
                this.$storage.set('uploadCertifyList', []);
                this.$router.push('/');
            }).catch(e=>{
                console.log(e);
                this.$dialog.alert(this.$setDialogMsg('w3-red','Kijelentkezés','Hiba történt a kijelentkezés során.'));         
            })            
        },                 
        closeMenu(){
            this.isShowMenu=false;
        },
        openMenu(){
            this.isShowMenu=true;
        },
        enabledCookie(){
            var reload=false;
            if (this.cookie==3) reload=true;
            this.cookie=1;
            this.$storage.set('cookieenabled', 1, {ttl: 365*24*60*60*1000});  
            if (reload) window.location.reload();
        },
        disabledCookie(){
            this.cookie=2;
            this.$storage.clear();
            this.$storage.set('cookieenabled', 2, {ttl: 365*24*60*60*1000});
            window.location.reload();
        },
      uploadOfflineCertify(){
        //offline állapotban történt teljesítések feltöltése                  
        var uploadCertifyList = this.$storage.get('uploadCertifyList', []);
        console.log(uploadCertifyList);
        if (uploadCertifyList.length>0) {
            var faforiteList=this.$storage.get('favoriteList', null);
            var len=uploadCertifyList.length;
            var uploadDb=0;
            for (var i=0; i<len; i++) {
                var cId=uploadCertifyList.pop();
                var cert=faforiteList[cId];
                if (cert) {
                    fb.UpdateCertify(cert).then(res=>{       
                        uploadDb++;         
                        if (uploadDb==len) { 
                            this.$dialog.alert(this.$setDialogMsg('w3-green','Teljesítések feltöltése','Offline teljesítések feltöltése sikeresen befejeződött'));
                            this.$storage.set('uploadCertifyList',[]);                            
                        }     
                    }).catch(e=>{
                        uploadCertifyList.push(cId);
                        this.$storage.set('uploadCertifyList',uploadCertifyList);                        
                        this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a teljesítési adatok feltöltése során.'));
                    })   
                } else {
                    uploadDb++;         
                    if (uploadDb==len) { 
                        this.$dialog.alert(this.$setDialogMsg('w3-green','Teljesítések feltöltése','Offline teljesítések feltöltése sikeresen befejeződött'));
                        this.$storage.set('uploadCertifyList',[]);                            
                    }  
                }
            } 
        }
      },               
    },
    mounted(){   
        this.$store.commit('setLoginProcess', this.$storage.get('isLoginProcess', false));   
        this.$hideSpinner();    
        if (this.isOnline) {
          this.uploadOfflineCertify();
        }  
        this.$on('online', function() {      
          this.uploadOfflineCertify();
        }); 
        if (!window.matchMedia('screen and (min-width: 993px)').matches) {
            this.isShowMenu=false;
        }
    },
    created(){
        this.cookie=this.$storage.get('cookieenabled', 0);
        if (this.cookie!=2) {
            var storedAppSettings=this.$storage.get('appSettings', false);
            const appSettings = require('./assets/jsons/appSettings.json'); 
            if (!storedAppSettings) { 
            this.$storage.set('appSettings', appSettings, {ttl: 365*24*60*60*1000});      
            }      
            if (storedAppSettings.settingVersion!=appSettings.settingVersion) {
                this.$storage.set('appSettings', appSettings, {ttl: 365*24*60*60*1000});
            } 
        }    
    }
}

</script>

<style>
@font-face {
  font-family: "LuckiestGuy";
  src: local("LuckiestGuy"),
   url(./fonts/Luckiest_Guy/LuckiestGuy-Regular.ttf) format("truetype");
}

.title-text{
    font-family: LuckiestGuy;
    font-size:60px;
    text-shadow: 3px 3px #224400;
    color:#fff;    
}
.font-1{
    font-family: LuckiestGuy;      
}
/* Create a Parallax Effect */
.bgimg-1 {
    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

/* First image (Logo. Full height) */
.bgimg-1 {
    background-image: url('./assets/img/parallax1.jpg');
    min-height: 100%;
}

.w3-wide {letter-spacing: 10px;}


/* Turn off parallax scrolling for tablets and phones */
@media only screen and (max-device-width: 1024px) {
    .bgimg-1 {
        background-attachment: scroll;
    }
}
.page-title{
    color:#224400;
    text-transform: uppercase;
    font-family: LuckiestGuy; 
    letter-spacing: 1px;
}
.route-title {
    color:#224400;
    text-transform: uppercase;
    font-family: LuckiestGuy; 
    letter-spacing: 1px;
}

.menu-title-color{
    color:#000 !important; background-color:#f1f1f1 !important
}

.menu-color{
    color:#000 !important; background-color:#fff !important
}

.main-color{
    color:#000 !important; background-color:#fff !important
}

.box-color{
    color:#000 !important; background-color:#f1f1f1 !important
}


.theme-1{
    color:#fff !important; background-color:#224400 !important
}

.flex-center-container {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.cursorpointer{
  cursor:pointer;
  text-decoration: none;
}

.responsive-img{
  width: 100%;
  max-width: 640px;
  height: auto;
}

.uppercase {
  text-transform: uppercase;
}

html, body, #app, #pagecontent, #maincontent {
  height: 100%;
  margin: 0;
  overflow: auto;
}

#container {
  display: flex; /* displays flex-items (children) inline */
  flex-direction: column; /* stacks them vertically */
  height: 100%; /* needs to take the parents height, alternative: body {display: flex} */
}

main {
  flex: 1; /* takes the remaining height of the "container" div */
  overflow: auto; /* to scroll just the "main" div */  
}

section {
  height: 100%; /* takes the visible area of the "main" div */
  overflow: auto; /* recommended */
}

</style>
